function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient",
  x1: -10253.11,
  y1: 2882.28,
  x2: -10070.67,
  y2: 2937.9,
  gradientTransform: "matrix(-.98 .18 .18 .98 -9988.19 -723.42)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2b2d61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#2e3065"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#373a6f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#464a82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#5c619b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#777fbc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#99a2e4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9aa4e6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-2",
  x1: -18.32,
  y1: 425.69,
  x2: -124.44,
  y2: 499.56,
  gradientTransform: "translate(569.76)",
  xlinkHref: "#quote_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-3",
  x1: -9783.46,
  y1: 455.39,
  x2: -9600.04,
  y2: 511.31,
  gradientTransform: "matrix(-1 0 0 1 -9128.97 0)",
  xlinkHref: "#quote_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-4",
  x1: -9765.2,
  y1: 395.51,
  x2: -9581.78,
  y2: 451.43,
  gradientTransform: "matrix(-1 0 0 1 -9128.97 0)",
  xlinkHref: "#quote_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-5",
  x1: -6079.01,
  y1: 2039.16,
  x2: -6188.57,
  y2: 1944.85,
  gradientTransform: "rotate(15.12 3785.305 26183.06)",
  xlinkHref: "#quote_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-6",
  x1: -9697.45,
  y1: 387.35,
  x2: -9769.42,
  y2: 215.31,
  gradientTransform: "matrix(-1 0 0 1 -9128.97 0)",
  xlinkHref: "#quote_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-7",
  x1: -9745.29,
  y1: 407.36,
  x2: -9817.26,
  y2: 235.32,
  gradientTransform: "matrix(-1 0 0 1 -9128.97 0)",
  xlinkHref: "#quote_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-8",
  x1: -232.55,
  y1: -1629.56,
  x2: -269.26,
  y2: -1699.97,
  gradientTransform: "scale(-1 1) rotate(-18.6 5576.767 571.327)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2b2d61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2b2d61",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-9",
  x1: 7100.38,
  y1: -2328.46,
  x2: 7145.18,
  y2: -2328.46,
  gradientTransform: "matrix(-.86 -.22 -.2 .98 1695.28 2961.13)",
  xlinkHref: "#quote_svg__linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-10",
  x1: 7100.38,
  y1: -2322.82,
  x2: 7145.18,
  y2: -2322.82,
  gradientTransform: "matrix(-.86 -.22 -.2 .98 1695.28 2961.13)",
  xlinkHref: "#quote_svg__linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-11",
  x1: 7100.38,
  y1: -2330.37,
  x2: 7145.18,
  y2: -2330.37,
  gradientTransform: "matrix(-.86 -.22 -.2 .98 1695.28 2961.13)",
  xlinkHref: "#quote_svg__linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_svg__linear-gradient-12",
  x1: -9746.78,
  y1: 306.77,
  x2: -9543.65,
  y2: 368.7,
  gradientTransform: "matrix(-1 0 0 1 -9128.97 0)",
  xlinkHref: "#quote_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "quote_svg__radial-gradient",
  cx: 597.09,
  cy: 516.87,
  r: 237.6,
  gradientTransform: "matrix(1 0 0 .57 0 221.01)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff901e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffc43d"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "quote_svg__clip-path",
  transform: "translate(-265.12 -243.49)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M574.52 282c16.14-11.19 54.65-6.6 72.31 28.82 5.72 11.45-16.52 3.66-7.91 28.19 12.58 35.89-68.33 43.07-86.14 33.56-4.12-2.2-15.93-38.28-7.06-47.5-3.18-8.44-1.9-14 .66-18.56 3.3-5.88 21.1-19.6 28.14-24.51z",
  fill: "none"
})), /*#__PURE__*/React.createElement("filter", {
  id: "quote_svg__AI_GaussianBlur_7"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7
})), /*#__PURE__*/React.createElement("style", null, ".quote_svg__cls-2{opacity:.25;filter:url(#quote_svg__AI_GaussianBlur_7)}.quote_svg__cls-12{fill:#fff}.quote_svg__cls-18{fill:#2b2d61}.quote_svg__cls-19{fill:#3eb883}.quote_svg__cls-20{fill:#8fe6c1}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M192.37 394.65c26.57 0 53.14.24 79.7-.14 8.42-.12 13.61 3 17.75 10.21q40.45 70 81.42 139.79c3.88 6.61 3.88 12.2-.06 18.88q-40.87 69.32-81.12 139c-4.32 7.49-9.58 10.7-18.33 10.65q-79.71-.43-159.41 0c-8.7 0-14.09-3-18.41-10.57q-39.11-68.37-79-136.32c-5.03-8.64-5.09-15.64-.03-24.28q40-68.34 79.2-137.17c4.18-7.33 9.48-10.25 17.76-10.16 26.83.29 53.68.11 80.53.11zm.07 72.14c-13.85 0-27.7.27-41.53-.11-6.84-.19-11 2.56-14.31 8.31-13.61 23.75-27.43 47.38-41.26 71-3 5.1-3.26 10-.26 15.16q21 36.26 41.95 72.57c3 5.2 7.49 7.49 13.24 7.65 4.8.12 9.6 0 14.41 0h66.11c6.16 0 11.75-1 15.29-7q21.74-36.83 43.64-73.55c2.87-4.82 2.72-9.45-.18-14.35q-21.4-36-42.54-72.23c-3.19-5.46-7.47-7.79-13.88-7.63-13.55.41-27.12.18-40.68.18zm127.98-272.76c-9 0-18.1-.18-27.13.07-6.07.16-10-2.26-12.95-7.56-11.1-19.67-22.5-39.17-33.79-58.73-1.55-2.69-3.09-5.38-4.73-8a10.76 10.76 0 00-9.82-5.48q-43.24.12-86.48 0c-6.31 0-9.61 3.43-12.47 8.44-12 21.09-24.43 42-36.33 63.13-3.33 5.93-7.55 8.36-14.28 8.26-17.51-.28-35.07-.73-52.55.15-10.27.51-16.81-8.1-10.53-18.73 24.39-41.33 48.28-83 72.12-124.6 3.36-5.88 7.37-8.22 14.2-8.19q82.67.35 165.32 0c6.78 0 10.93 2.26 14.29 8.13 22.86 39.93 46 79.72 69 119.56a80.07 80.07 0 014.44 8.19c3.53 8.12-.64 15-9.49 15.31-9.6.27-19.22.04-28.82.05zm177.27 339.34c-27.42 0-54.84-.2-82.25.14-6.89.08-10.85-2.51-14.16-8.3q-35.79-62.48-72-124.72c-.42-.73-1-1.41-1.31-2.17-4.09-8.54-.13-15.66 9.3-16 9.88-.36 19.78-.09 29.67-.1 8.2 0 16.41.36 24.58-.1 7.19-.41 11.59 2.6 15 8.67 9.56 17 19.43 33.76 29.17 50.63 2.41 4.16 4.77 8.34 7.17 12.49 3.08 5.33 7.53 8.06 13.87 8q41.11-.13 82.24 0c6.61 0 11.08-2.77 14.37-8.54 11.62-20.35 23.76-40.4 35.14-60.88 4.23-7.62 9.48-10.81 18.28-10.47 15.52.61 31.08.17 46.63.17 1.69 0 3.39-.07 5.08 0 9.89.61 14.06 7.65 9.26 16.44-6.48 11.89-13.41 23.55-20.18 35.29-17.06 29.59-34.27 59.11-51.11 88.83-4.2 7.41-9.32 10.91-18.24 10.74-26.81-.45-53.66-.12-80.51-.12zm157.25-165.93c-16.92-.85-33.92-.4-50.88-.12-6.75.11-11-2.42-14.3-8.31-11.93-21.16-24.46-42-36.28-63.19-3.53-6.33-8-8.7-15-8.61-19.22.24-38.45.1-57.68.07-3.1 0-6.2-.24-9.3-.38-4.79.13-9.58.49-14.36.31-6.35-.24-10.58 2.34-13.73 7.88-11.41 20.11-23.07 40.08-34.64 60.1-1.13 2-2.34 3.86-3.4 5.85a10.83 10.83 0 01-10.3 6.13c-19.19 0-38.39.28-57.58-.07-10.35-.19-14-7.68-8.67-17.16 11.41-20.11 23.07-40.08 34.64-60.09 12.67-21.92 25.5-43.75 37.95-65.8 3.31-5.87 7.46-8.47 14.23-8.33 18.62.39 37.25.33 55.87.44 2.25-.12 4.5-.35 6.76-.35 33.64 0 67.29.17 100.94-.13 7.68-.07 12.47 2.36 16.37 9.2 23.34 41 46.76 81.94 70.88 122.47 7.01 11.75 2.13 20.77-11.52 20.09zM347.99 209.31c-18.32-.11-36.64.14-55-.13-6.18-.09-9.93 2.47-12.86 7.65q-13.71 24.26-27.87 48.27c-3.3 5.56-3.59 10.48.75 15.43 9.19 16.15 18.1 32.48 27.7 48.39 4.62 7.66 13.44 6.8 18.34-1.56 8.71-14.83 17-29.9 25.48-44.88 11.23-19.17 22.69-38.21 33.58-57.57 4.77-8.4-.13-15.53-10.12-15.6zM167.93 341.1q-11.31-19.29-22.69-38.53c-2.13-4-4.16-8-6.41-11.88-14.23-24.69-28.55-49.33-42.72-74.06-2.58-4.51-5.69-7.43-11.27-7.39-19.21.12-38.42.09-57.63 0-3.69 0-6.66 1.12-8.76 4.13-3 4.25-2.19 8.5.25 12.7 4.26 7.32 8.46 14.67 12.73 22q16 27.37 32.1 54.72c9.44 16.64 19 33.2 28.26 50 3.1 5.63 7.2 7.93 13.61 7.83 17.77-.27 35.55-.09 53.32-.1a29.23 29.23 0 003.38-.09c7.1-.85 11-6.48 8.9-13.28a29 29 0 00-3.07-6.05zm96.22-8q-10.8-19.1-21.58-38.21a10.83 10.83 0 00-10.34-5.94c-19.17.08-38.34-.11-57.51.1-8.89.1-13.5 7.23-9.33 15.06 5.92 11.15 12.76 21.82 19.21 32.69 3.36 6.14 6.67 12.32 10.11 18.42a9.77 9.77 0 009 5.22c19.71 0 39.42.24 59.12-.11 8.34-.14 12.34-7.42 8.65-15-2.06-4.24-4.85-8.16-7.33-12.24z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M181.25 379.7c26.57 0 53.14.24 79.71-.14 8.42-.12 13.6 3 17.75 10.21q40.44 70.05 81.41 139.8c3.88 6.6 3.88 12.19-.06 18.87q-40.86 69.32-81.12 139c-4.32 7.48-9.58 10.69-18.33 10.64q-79.71-.43-159.41 0c-8.7 0-14.09-3-18.41-10.57q-39.11-68.37-79-136.33c-5.08-8.62-5.14-15.64-.1-24.25q40-68.34 79.2-137.17c4.18-7.33 9.49-10.24 17.76-10.16 26.9.28 53.75.1 80.6.1zm.07 72.15c-13.84 0-27.7.26-41.53-.12-6.84-.18-11 2.56-14.31 8.31-13.61 23.75-27.43 47.39-41.26 71-3 5.1-3.26 10-.26 15.17q21 36.24 42 72.56c3 5.21 7.48 7.5 13.23 7.65 4.8.13 9.61 0 14.41 0h66.11c6.16 0 11.75-1 15.3-7q21.74-36.82 43.64-73.55c2.86-4.82 2.72-9.45-.19-14.34q-21.4-36-42.54-72.24c-3.19-5.46-7.47-7.78-13.88-7.62-13.59.41-27.16.18-40.72.18zM309.3 179.08c-9 0-18.09-.17-27.13.07-6.06.16-10-2.26-12.95-7.56-11.1-19.67-22.49-39.17-33.79-58.73-1.55-2.68-3.09-5.38-4.73-8a10.74 10.74 0 00-9.82-5.48q-43.24.11-86.48 0c-6.31 0-9.6 3.43-12.47 8.45-12 21.08-24.43 42-36.33 63.12-3.33 5.93-7.55 8.37-14.27 8.26-17.52-.28-35.08-.73-52.56.15-10.27.51-16.8-8.1-10.53-18.73 24.4-41.33 48.28-82.95 72.12-124.6 3.36-5.87 7.38-8.22 14.2-8.19q82.67.34 165.32 0c6.78 0 10.93 2.26 14.29 8.13 22.86 39.93 46 79.72 69 119.56a80.07 80.07 0 014.44 8.19c3.53 8.13-.64 15-9.49 15.31-9.6.28-19.24.05-28.82.05zm177.27 339.34c-27.42 0-54.83-.2-82.25.14-6.89.09-10.84-2.51-14.16-8.3q-35.79-62.47-72-124.72c-.42-.73-1-1.41-1.31-2.17-4.08-8.53-.13-15.65 9.3-16 9.88-.36 19.78-.1 29.67-.1 8.2 0 16.42.35 24.59-.11 7.18-.4 11.58 2.61 15 8.67 9.56 17 19.43 33.77 29.18 50.64 2.4 4.15 4.76 8.33 7.16 12.49 3.08 5.32 7.53 8.06 13.87 8q41.12-.15 82.24 0c6.61 0 11.08-2.78 14.37-8.55 11.62-20.34 23.76-40.4 35.14-60.88 4.24-7.62 9.48-10.8 18.28-10.46 15.52.6 31.08.17 46.63.17 1.69 0 3.39-.08 5.08 0 9.9.6 14.06 7.64 9.27 16.43-6.49 11.9-13.42 23.55-20.19 35.29-17.06 29.6-34.27 59.11-51.11 88.83-4.2 7.42-9.31 10.92-18.24 10.75-26.81-.45-53.67-.12-80.52-.12z",
  fill: "#ffc43d"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M909 596c-16.93-.85-33.93-.39-50.89-.12-6.74.11-11-2.42-14.29-8.31-11.94-21.15-24.47-42-36.29-63.19-3.53-6.33-8-8.7-15-8.61-19.23.24-38.46.11-57.69.07-3.1 0-6.19-.24-9.29-.37-4.79.12-9.59.49-14.37.3-6.35-.24-10.58 2.34-13.73 7.89-11.41 20.11-23.07 40.07-34.64 60.09-1.13 2-2.34 3.87-3.4 5.85a10.8 10.8 0 01-10.29 6.13c-19.2 0-38.4.28-57.59-.07-10.35-.19-14-7.68-8.67-17.15 11.41-20.12 23.07-40.08 34.64-60.1 12.68-21.92 25.51-43.75 37.95-65.8 3.31-5.86 7.47-8.46 14.23-8.32 18.62.38 37.25.32 55.87.44 2.25-.13 4.51-.35 6.76-.35 33.65 0 67.3.16 100.94-.14 7.68-.07 12.47 2.36 16.37 9.2 23.34 41 46.76 81.94 70.89 122.47 6.97 11.74 2.08 20.75-11.51 20.09zM602 437.86c-18.32-.12-36.64.13-55-.13-6.17-.09-9.93 2.46-12.85 7.64q-13.71 24.27-27.88 48.28c-3.3 5.55-3.59 10.47.75 15.42 9.19 16.16 18.1 32.48 27.7 48.39 4.62 7.66 13.44 6.8 18.35-1.55 8.7-14.84 17-29.91 25.47-44.88 11.23-19.17 22.69-38.22 33.59-57.57 4.76-8.41-.13-15.54-10.13-15.6zM421.93 569.64q-11.31-19.29-22.69-38.53c-2.13-4-4.16-8-6.4-11.88-14.23-24.69-28.55-49.33-42.72-74.06-2.59-4.5-5.7-7.43-11.28-7.39-19.21.12-38.42.09-57.62 0-3.7 0-6.67 1.13-8.77 4.13-3 4.25-2.19 8.5.26 12.7 4.25 7.32 8.45 14.67 12.73 22q16 27.38 32.09 54.72c9.45 16.63 19 33.19 28.26 49.95 3.1 5.64 7.21 7.93 13.61 7.83 17.77-.27 35.55-.09 53.32-.09a29.46 29.46 0 003.39-.1c7.09-.84 10.95-6.47 8.89-13.28a29.5 29.5 0 00-3.07-6zm96.22-8q-10.78-19.1-21.57-38.2a10.86 10.86 0 00-10.35-5.95c-19.17.09-38.34-.11-57.51.1-8.88.1-13.5 7.23-9.33 15.07 5.92 11.14 12.76 21.81 19.21 32.68 3.36 6.15 6.67 12.32 10.11 18.42a9.75 9.75 0 009 5.22c19.71 0 39.42.24 59.12-.1 8.35-.15 12.34-7.43 8.65-15-2.06-4.25-4.85-8.17-7.33-12.25z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__radial-gradient)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M435.73 54.83a2.61 2.61 0 00-1.89-4 2.54 2.54 0 00-1.5.25c-17.07 8.44-29.62 8.47-37.93 8.49-4.11 0-7.35 0-10 1a16.62 16.62 0 00-3.22 1.59c-19.5-22.84-49.59-24.82-63.37-15.26-1 .68-2.15 1.52-3.47 2.49-3.94-4.48-7.21-10.65-5.62-21.63-6.67 4.86-14.52 13.8-16.6 25.44-1.17 6.53-3.61 11.67-5.37 16.58-2.39-14.72-2.35-33.86-2.72-42.36-.58-13.38-22.26-26.8-26.06-13.68a8.84 8.84 0 00-5.56 1.48c-2.57 1-4.84 3.42-6 8.48-4.39 0-9.5 2.15-10.28 11.47 9.93.24 14.73-.11 14.73 5.38 0 9.71-8 62.31.93 80.37 5.33 10.82 22.19 26.9 40 38.19a99.64 99.64 0 00-3.24 10.48c-10.46-2.08-21.86-2.89-32.29-.45-34.47 8.05-16.62 68.26-16.62 68.26s-21.94-3.61-22.16 7a25.49 25.49 0 0110.58 1.79s-10.11 3.68-9.26 10.81a33.11 33.11 0 0114.31.94s-10.65 4.91-9.52 11.26c13.15-1.94 21 5.7 34.93-2.86s14.77-44.54 14.77-44.54l18.64 2.9c-4.92 32.93 54.64 42.59 54.64 42.59s-15.71 12.49-9.62 22.82a28.31 28.31 0 0112.41-8.6s-3.47 8.94 3 13.41c5.24-9.11 11.15-12.52 11.15-12.52s-4.34 10.24 4.63 13.13c3.22-10.94 14.25-16.47 12.59-32.71-1.42-13.8-24.75-27.71-31.74-31.58 8.15-5.25 19.52-12.91 23.92-33.51 5.42-25.37-7.79-36.16-1.74-68.1 6.62-4.1 11.18-9.37 12.11-15.9h.14l1.12.23c5.91 1.18 9.44.72 12.83-.28l-.6-2.24-1.63-6.14 8.21 5.6c.67-.46 1.3-1 1.92-1.46s1.26-1.08 1.86-1.64a31.69 31.69 0 006.4-8.57c.15-.3.32-.6.46-.9l-3.6-3.55-1.78-1.76 7.7-.14.36-1.07c.22-.71.43-1.41.61-2.07.1-.33.18-.65.26-1 3.2-12.88 12.09-22.88 14.79-27.85l.13-.24c.64-1.17 2.13-3.91 2.9-5.27l.35-.61z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M505.71 258.44c.35-8 4.87-9.72 9-9.58 3.81-13.12 25.49.3 26.07 13.68.59 13.65.13 54.72 10.33 60.92 14.24 8.64 64.91 15.9 60.41 42.51-4.87 28.83-71.38-3.48-85.44-22.47-10.77-14.53-10.33-58.22-11.89-66.8-.87-4.85-6.88-7.86-15.7-6.47-.83-8.37 3.35-11.05 7.22-11.79z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M581.14 417.08l-20.22 44.62-30.92-4.81s-.87 36-14.78 44.54-21.77.91-34.93 2.86c-1.13-6.35 9.53-11.27 9.53-11.27a33.14 33.14 0 00-14.31-.94c-.85-7.13 9.25-10.8 9.25-10.8a25.38 25.38 0 00-10.58-1.8c.23-10.57 22.17-7 22.17-7s-17.85-60.2 16.62-68.26c30.03-6.98 68.17 12.86 68.17 12.86z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-2)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M549 457.77c6.71-30.07 35.48-47.25 35.48-47.25l40.09 23.77-20.76 31s32.05 16.4 33.71 32.64-9.36 21.78-12.58 32.71c-9-2.89-4.63-13.12-4.63-13.12s-5.92 3.4-11.15 12.52c-6.49-4.48-3-13.41-3-13.41a28.22 28.22 0 00-12.5 8.58c-6.08-10.34 9.63-22.82 9.63-22.82s-62.03-10.06-54.29-44.62z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-3)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M561.81 364.71c13.77-30.35 71-20.73 67.26-5.29-8.67 36.16 6.32 46.69.61 73.42-5.37 25.1-21.07 31-28.71 36.71-18.36 13.77-47.32-14.88-55.58-38.44-7.74-22.05 8.91-49.85 16.42-66.4z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-4)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M577.85 306.06c12.51-18.6-16.57-14.47-12.42-43.18-6.66 4.86-14.52 13.8-16.6 25.44-2.29 12.83-9.52 20.33-6.82 31.21 2.51 10.1 14.28 10.68 20 7.39 9.47-5.5 10.99-13.66 15.84-20.86z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-5)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M574.52 282c16.14-11.19 54.65-6.6 72.31 28.82 5.72 11.45-16.52 3.66-7.91 28.19 12.58 35.89-68.33 43.07-86.14 33.56-2.27-1.21-12.46-17.45-9.07-25.63-.8-4.2-.12-3.12-.45-7.32-5.9-4.23.24-12.24 2.46-14.55-3.18-8.44-1.9-14 .66-18.56 3.3-5.88 21.1-19.6 28.14-24.51z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-6)"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#quote_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  className: "quote_svg__cls-12",
  d: "M535.57 341c-1.83-1.74-4.58-4.76-3.63-7.08a.2.2 0 01.26-.09.22.22 0 01.13.1c1.12 2.19 3.71 3.66 6.36 4.56.11 0 .17.13.13.22l-2.9 2.26a.26.26 0 01-.3 0zm4.62 3.63a33.87 33.87 0 01-3.11-2.26.22.22 0 010-.35l3.14-2.46a.24.24 0 01.29 0 .14.14 0 01.06.12l.12 4.75c-.01.3-.23.37-.5.2zm2.14.46l-.12-5a.53.53 0 01.6-.46h.12l1.12.21c1 .17 2.13.37 3.39.49h.26c.34 0 .6.29.57.56a.44.44 0 01-.17.3l-5.42 4a.26.26 0 01-.29 0 .17.17 0 01-.06-.1zm9.95 5.05a65.43 65.43 0 01-7.84-3.15.63.63 0 01-.34-.91.66.66 0 01.14-.15c1.62-1.21 5.35-4 6.36-4.75a.24.24 0 01.29 0s.06.06.06.09l2.4 8.16c.11.36-.17.69-.61.75a1.21 1.21 0 01-.46-.04zm2.94.29l-2.5-8.73c-.11-.36.17-.7.61-.75h.21l3.31.26c1.94.15 3.84.3 5.94.53a.56.56 0 01.57.55.34.34 0 01-.11.25l-7.65 8a.25.25 0 01-.29 0 .18.18 0 01-.09-.11zm10.51 3.22c-2.75-.57-5.3-1.17-7.7-1.81a.7.7 0 01-.59-.83.45.45 0 01.12-.21l6.58-6.95a.24.24 0 01.29 0 .15.15 0 01.08.11l2.16 9c.09.36-.2.68-.64.72a1 1 0 01-.3-.03zm3.08-.23a.22.22 0 01-.28.06.25.25 0 01-.11-.12L565.93 343c-.09-.37.21-.69.65-.73a.65.65 0 01.24 0c1.13.16 2.34.35 3.65.58s2.52.47 3.64.7a.73.73 0 01.66.8.67.67 0 01-.07.18zm10.19 2.12c-2.46-.23-5.07-.53-7.85-.93a.79.79 0 01-.74-.77.47.47 0 01.09-.22l5.1-7.73a.22.22 0 01.27-.05.22.22 0 01.11.1l3.82 8.77a.59.59 0 01-.5.81 1 1 0 01-.3.02zm2.78-.42L577.31 345a.44.44 0 01.37-.6.78.78 0 01.34 0c2 .5 3.87 1 5.77 1.54l3.45.94c.33.09.54.37.46.62a.34.34 0 01-.06.12l-5.46 7.53a.22.22 0 01-.27.08.22.22 0 01-.13-.11zm11.69.49a64.31 64.31 0 01-8.46.28.83.83 0 01-.85-.68.52.52 0 01.1-.34l5-6.84a.22.22 0 01.28 0 .27.27 0 01.08.07c.69 1.07 3.24 4.95 4.36 6.64a.57.57 0 01-.34.87zm4.46-5.77l-1.83 4.7a.2.2 0 01-.25.1.25.25 0 01-.13-.09l-3.72-5.64a.43.43 0 01.24-.65.85.85 0 01.42 0l.27.06c1.22.31 2.35.51 3.35.69l1.13.19a.57.57 0 01.55.56.36.36 0 01-.03.08zm4.07 3.93a31.45 31.45 0 01-3.69 1.08c-.31.07-.49-.09-.39-.33l1.73-4.44a.2.2 0 01.25-.1.19.19 0 01.12.09l2.11 3.38a.21.21 0 01-.12.32zm3.27-1.39c-.43.23-.9.44-1.37.66a.26.26 0 01-.29-.07l-2-3.12a.14.14 0 01.08-.22h.09a14.85 14.85 0 004.69-.53 7.14 7.14 0 002.85-1.58.26.26 0 01.29 0 .16.16 0 01.08.13 2.62 2.62 0 01-.13.83c-.39 1.29-1.89 2.65-4.29 3.9z",
  transform: "translate(-265.12 -243.49)",
  id: "quote_svg__Teeth"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M692.18 286.81a2.64 2.64 0 00-1.6-.84 2.72 2.72 0 00-1.5.25c-17.06 8.45-29.62 8.48-37.93 8.5-4.1 0-7.35 0-10 .95a16.72 16.72 0 00-6.2 4c-6.7 8-9 37.7 3.83 48.83a29.45 29.45 0 0015.36.28l-2.24-8.38 8.22 5.6a32 32 0 0010.64-12.58l-5.39-5.3 7.71-.14c.49-1.44.91-2.87 1.23-4.11C677.5 311 686.4 301 689.1 296.07c.62-1.14 2.83-5.23 3.38-6.13a2.61 2.61 0 00-.3-3.13z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-7)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M639.05 319c2.12-3.56 4.59-8.77 17-11.6l.22-.05a69.6 69.6 0 0014.82-4 75.58 75.58 0 0021.4-13.43c-.55.9-2.76 5-3.38 6.13-2.7 5-11.6 15-14.79 27.84-.32 1.24-.74 2.67-1.23 4.11l-7.71.14 5.39 5.3A32 32 0 01660.12 346l-8.22-5.6 2.24 8.38c-3.85 1.13-7.88 1.58-15.39-.3-.11-1-.25-2-.39-2.93-1.31-8.45-3.15-20.08.69-26.55z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-8)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M586.16 284.93c-1.23-1-6.95-.36-6.95-.36-1.36.18-2.29 1.29-1.59 2.06a7 7 0 005.94 1.44c2.82-.55 3.83-2.14 2.6-3.14z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-9)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M586.43 291c-3.23.08-1.57 3.77.34 4.26s4.92-.57 4.56-1.94-3.23-2.38-4.9-2.32z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-10)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M596.63 284.56c-2.32-.37-5.29 2.4-5.52 3.59-.28 1.48 1.34 2.16 5.34 2.92s7.72-1.31 7.75-2.56-5.23-3.63-7.57-3.95z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-11)"
});

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "quote_svg__b_w_mascot",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "quote_svg__Brow_Eyes",
  "data-name": "Brow + Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "quote_svg__cls-18",
  d: "M578.19 327.1a18.24 18.24 0 01-4.88-1.9s3.42-.81 8.15-2c13-3.41 21.94-9.78 28.43-8.8 3.91.58 4.38 6.21 4.38 6.21a19.15 19.15 0 00-6.37-1.77c-3.74-.29-8.22 1.08-13.51 3",
  transform: "translate(-265.12 -243.49)"
}), /*#__PURE__*/React.createElement("path", {
  className: "quote_svg__cls-19",
  d: "M594.39 321.82c8.31-.89 12.06.09 12.06.09a16.62 16.62 0 01-.81 4.64c-1.67 5.47-6.48 10.35-15.13 9.32a14.6 14.6 0 01-12.32-8.77",
  transform: "translate(-265.12 -243.49)"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "quote_svg__b_w_mascot-2",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("path", {
  className: "quote_svg__cls-20",
  d: "M589.72 325.24c6-1.32 9.14-.71 9.14-.71a10.08 10.08 0 01-.47 2.73c-1 3.2-3.81 6.07-8.89 5.47a8.59 8.59 0 01-7.24-5.15s1.47-1.02 7.46-2.34z",
  transform: "translate(-265.12 -243.49)",
  id: "quote_svg__Brow_Eyes-2",
  "data-name": "Brow + Eyes"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "quote_svg__b_w_mascot-3",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "quote_svg__Brow_Eyes-3",
  "data-name": "Brow + Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "quote_svg__cls-18",
  d: "M553.7 318.93c-2.46-2.11-4.54-3.72-6.49-4a7.36 7.36 0 00-3.49.41s1-4.07 3-4c3.42.15 7.19 6 13.34 10.23a55.89 55.89 0 005 3c.35.19-2.34.2-3.89.31",
  transform: "translate(-265.12 -243.49)"
}), /*#__PURE__*/React.createElement("path", {
  className: "quote_svg__cls-19",
  d: "M561.26 325c-1.73 3.37-4.58 5.2-7.38 4.76-4.53-.4-6.35-4.61-6.51-8.83a17.13 17.13 0 01.19-3.5s2-.21 6.14 1.55",
  transform: "translate(-265.12 -243.49)"
})));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  id: "quote_svg__b_w_mascot-4",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("path", {
  className: "quote_svg__cls-20",
  d: "M555.54 322.44a10 10 0 00-4.31-1.62 8.64 8.64 0 00-.12 1.76c.07 2.11 1.06 4.25 3.59 4.53a4.13 4.13 0 004.14-2.26 11.75 11.75 0 00-3.3-2.41z",
  transform: "translate(-265.12 -243.49)",
  id: "quote_svg__Brow_Eyes-4",
  "data-name": "Brow + Eyes"
}));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "quote_svg__cls-12",
  d: "M321.73 82.51s-4.15.05-4.65 1.79 6.22-.67 7.85-.94.37-1.21-3.2-.85zm-31.31-3.39s2.48.85 2.52 2.37-3.62-1.77-4.56-2.31 0-1.06 2-.06z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M503.14 258.82c2-8.72 7.27-9.69 11.73-8.72 6.78-13.62 27.87 5.39 25.84 20.16-2.06 15.08-10.73 60-.78 68.8 13.88 12.3 68 30.33 57.73 58.58-11.07 30.61-77.51-18-89.15-41.6-8.9-18.06-.92-70.66-.92-80.38 0-5.48-4.8-5.14-14.73-5.37.78-9.29 5.89-11.44 10.28-11.47z",
  transform: "translate(-265.12 -243.49)",
  fill: "url(#quote_svg__linear-gradient-12)"
});

function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 669.77 713.02"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

export default __webpack_public_path__ + "static/quote.97813aea.svg";
export { SvgQuote as ReactComponent };